import { Switch, useRouteMatch } from 'react-router-dom';
import { Suspense, lazy } from 'react';

import ProtectedRoute from 'routers/ProtectedRoute';
import LinearProgress from 'components/LinearProgress';
const Dashboard = lazy(() => import('pages/client/Dashboard'));

export default function ClientRoutes(): JSX.Element {
  const { path } = useRouteMatch();

  return (
    <Suspense fallback={<LinearProgress />}>
      <Switch>
        <ProtectedRoute role="client" path={path}>
          <Dashboard />
        </ProtectedRoute>
      </Switch>
    </Suspense>
  );
}
